import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// PrimeNG standalone components
import { Accordion } from "primeng/accordion";
import { AccordionModule } from 'primeng/accordion';
import { Breadcrumb } from "primeng/breadcrumb";
import { Button } from "primeng/button";
import { Calendar } from "primeng/calendar";
import { Card } from "primeng/card";
import { Carousel } from "primeng/carousel";
import { Checkbox } from "primeng/checkbox";
import { ConfirmDialog } from "primeng/confirmdialog";
import { Dialog } from "primeng/dialog";
import { Editor } from "primeng/editor";
import { FileUpload } from "primeng/fileupload";
import { InputSwitch } from "primeng/inputswitch";
import { InputText } from "primeng/inputtext";
import { Message } from "primeng/message";
import { MultiSelect } from "primeng/multiselect";
import { Paginator } from "primeng/paginator";
import { Panel } from "primeng/panel";
import { Popover } from "primeng/popover";
import { RadioButton, RadioButtonModule } from "primeng/radiobutton";
import { RatingModule } from "primeng/rating";
import { ScrollPanel } from "primeng/scrollpanel";
import { Sidebar } from "primeng/sidebar";
import { Steps } from "primeng/steps";
import { TabMenu } from "primeng/tabmenu";

import { TableModule } from "primeng/table";
import { Textarea } from "primeng/textarea";
import { Toast } from "primeng/toast";
import { Tooltip } from "primeng/tooltip";
import { DropdownModule } from "primeng/dropdown";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PopoverModule } from "primeng/popover";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { PaginatorModule } from "primeng/paginator";
import { SelectModule } from "primeng/select";
import { DrawerModule } from "primeng/drawer";
import { DatePickerModule } from "primeng/datepicker";

// PrimeNG services
import { ConfirmationService, MessageService } from "primeng/api";

const PRIMENG_MODULES = [
  Accordion,
  AccordionModule,
  Breadcrumb,
  Button,
  Calendar,
  Card,
  Carousel,
  Checkbox,
  ConfirmDialog,
  Dialog,
  DropdownModule,
  Editor,
  FileUpload,
  InputSwitch,
  InputText,
  Message,
  MultiSelect,
  Paginator,
  Panel,
  Popover,
  RadioButton,
  RadioButtonModule,
  RatingModule,
  ScrollPanel,
  Sidebar,
  Steps,
  TabMenu,

  TableModule,
  Textarea,
  Toast,
  Tooltip,
  OverlayPanelModule,
  PopoverModule,
  ToggleSwitchModule,
  PaginatorModule,
  SelectModule,
  DrawerModule,
  DatePickerModule,
];

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ...PRIMENG_MODULES],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, ...PRIMENG_MODULES],
  providers: [ConfirmationService, MessageService],
})
export class PrimeNgModule {}
